import React from 'react';
import { makeStyles } from '@mui/styles';
import { TextField } from '@mui/material';

const TextArea = React.forwardRef((props, ref) => {
	const useStyles = makeStyles(() => ({
		textField: {
			position: 'relative',
			overflow: 'auto',
			maxHeight: '200px',
		},
	}));

	const classes = useStyles();

	return (
		<>
			<TextField
				ref={ref}
				variant='outlined'
				multiline={true}
				className={classes.textField}
				{...props}
			/>
		</>
	);
});

export default TextArea;
